import React from 'react';

function FinalCTA() {
  return (
    <section id="final">
      <div className="wrap">
        <div className="final">
          <h2>You just talked to Salesyo.<br />Now imagine it on your conversations.</h2>
          <p>Book 30 minutes. We plug it into your account in demo mode, and you watch it drive your real conversations to the close.</p>
          <div className="hero-cta center" style={{ marginBottom: 0 }}>
            <a href="https://calendly.com/salesyo-ai/30min" target="_blank" rel="noopener noreferrer" className="btn btn-wa">Book my free demo</a>
            <a href="#cycle" className="btn btn-ghost" style={{ color: '#fff', borderColor: 'rgba(255,255,255,.3)' }}>See the cycle again</a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FinalCTA;
